import Container from '@/components/templates/container'
import Title from './title'
import MainImage from './mainImage'
import Description from './description'

const OurApproach = ({ title, description, image }) => {
  const base =
    'relative w-full flex flex-col lg:flex-row justify-between gap-smallMobile md:gap-[40px]'
  const baseContent = 'order-2 lg:order-1 relative w-full lg:max-w-[550px]'

  return (
    <Container outerClassName="mt-mediumDesktop lg:mt-largeDesktop">
      <div className={base}>
        <div className={baseContent}>
          <Title text={title} />
          <Description text={description} />
        </div>
        <MainImage image={image} />
      </div>
    </Container>
  )
}

export default OurApproach
